import { PreferredRoommatesState, PreferredRoommatesActionTypes, PREFERRED_ROOMMATES_DATA_REQUEST, PREFERRED_ROOMMATES_DATA_SUCCESS, PREFERRED_ROOMMATES_DATA_FAILURE } from "store/reducers/lodgingRequest/preferredRoommates/types";

const defaultState: PreferredRoommatesState = {
  isLoading: false,
  errorMessage: ""
};

export default function preferredRoommates(state = defaultState, action: PreferredRoommatesActionTypes): PreferredRoommatesState {
  switch (action.type) {
    case PREFERRED_ROOMMATES_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case PREFERRED_ROOMMATES_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case PREFERRED_ROOMMATES_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};